import { Input } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { ICommonInputProps } from './types';

const InputContainerStyled = styled.div<{ $prefix?: string; $affix?: string }>`
  position: relative;
  width: 100%;
`;

const TextOnly: React.FC<ICommonInputProps> = ({
  disabled,
  name,
  onBlur,
  type,
  placeholder,
  defaultValue,
  inputSettings,
  inputClassName,
  onChange,
  value,
}) => {
  const handleChange = (e: any) => {
    onChange?.(e.target.value, name);
  };

  return (
    <InputContainerStyled className={`text-input ${inputClassName}`}>
      <Input
        style={{
          display: 'none',
        }}
        name={name}
        value={value}
        defaultValue={defaultValue || undefined}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        onChange={handleChange}
        onBlur={onBlur}
      />
      <div style={{ display: inputSettings?.show ? 'block' : 'none' }}>
        {inputSettings?.displayValue || value || defaultValue}
      </div>
    </InputContainerStyled>
  );
};

export default React.memo(TextOnly);
